import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { FORM_DATA_DROPDWON_SELECT_1 } from '../../data/data';

type SurveyOption = {
  label: string;
  label_en: string;
  value: string;
  code: string;
  selected?: boolean;
};

type SurveyModule = {
  type: string;
  id: number;
  label: string;
  label_en: string;
  required?: boolean;
  options: SurveyOption[];
};

@Component({
  selector: 'app-sign-in-step-survey-1',
  templateUrl: './sign-in-step-survey-1.component.html',
  styleUrls: ['./sign-in-step-survey-1.component.scss'],
})
export class SignInStepSurvey1Component implements OnInit, OnDestroy {
  readonly formData = FORM_DATA_DROPDWON_SELECT_1;
  readonly modules: SurveyModule[] = FORM_DATA_DROPDWON_SELECT_1.modules as SurveyModule[];

  //@Input() surveyObjective = '';
  //@Input() surveyRisk = '';
  //@Input() surveyInvolvement = '';
  @Input() surveyObjective: {value: string;code: string;} = { value: '', code: '' };
  @Input() surveyRisk: {value: string;code: string;} = { value: '', code: '' };
  @Input() surveyInvolvement: {value: string;code: string;} = { value: '', code: '' };
  

  // @Output() surveyObjectiveChange = new EventEmitter<string>();
  // @Output() surveyRiskChange = new EventEmitter<string>();
  // @Output() surveyInvolvementChange = new EventEmitter<string>();
  @Output() surveyObjectiveChange = new EventEmitter<{ value: string; code: string }>();
  @Output() surveyRiskChange = new EventEmitter<{ value: string; code: string }>();
  @Output() surveyInvolvementChange = new EventEmitter<{ value: string; code: string }>();
  
  @Output() goToStep = new EventEmitter<number>();

  private langSub?: Subscription;

  constructor(
    public translateService: TranslateService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.langSub = this.translateService.onLangChange.subscribe(() =>
      this.cdr.markForCheck(),
    );
  }

  ngOnDestroy(): void {
    this.langSub?.unsubscribe();
  }

  isSpanish(): boolean {
    return this.translateService.getCurrentLang() === 'es';
  }

  moduleLabel(mod: SurveyModule): string {
    return this.isSpanish() ? mod.label : mod.label_en;
  }

  optionLabel(opt: SurveyOption): string {
    return this.isSpanish() ? opt.label : opt.label_en;
  }

  headerTitle(): string {
    return this.isSpanish() ? this.formData.title : this.formData.title_en;
  }

  headerSubtitle(): string {
    return this.isSpanish() ? this.formData.subtitle : this.formData.subtitle_en;
  }

  get isSurveyComplete(): boolean {
    return (
      !!this.surveyObjective?.value.trim() &&
      !!this.surveyRisk?.value.trim() &&
      !!this.surveyInvolvement?.value.trim()
      //!!this.surveyObjective?.trim() &&
      //!!this.surveyRisk?.trim() &&
      //!!this.surveyInvolvement?.trim()
    );
  }

  selectedValue(moduleIndex: number): string | { value: string; code: string } {
    switch (moduleIndex) {
      case 0:
        //return this.surveyObjective;
        return { value: this.surveyObjective.value, code: this.surveyObjective.code };
      case 1:
        return this.surveyRisk;
      case 2:
        return this.surveyInvolvement;
      default:
        return '';
    }
  }

  onOptionChange(moduleIndex: number, value: string): void {

    const module = this.formData.modules[moduleIndex];
    const selectedOption = module.options.find((option: any) => option.value === value);

    if (!selectedOption) return;

    switch (moduleIndex) {
      case 0:
        this.surveyObjectiveChange.emit({ value: selectedOption.value, code: selectedOption.code });
        break;
      case 1:
        //this.surveyRiskChange.emit(selectedOption.value);
        this.surveyRiskChange.emit({ value: selectedOption.value, code: selectedOption.code });
        break;
      case 2:
        //this.surveyInvolvementChange.emit(selectedOption.value);
        this.surveyInvolvementChange.emit({ value: selectedOption.value, code: selectedOption.code });
        break;
      default:
        break;
    }
  }

}
